var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRotate360(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C2.97631 6.88155 2 9.44078 2 12M4.92893 19.0711C8.83418 22.9763 15.1658 22.9763 19.0711 19.0711C21.0237 17.1184 22 14.5592 22 12M20 2V5.9C20 5.95523 19.9552 6 19.9 6H16M4 22V18.1C4 18.0448 4.04477 18 4.1 18H8",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotate360);
export default __webpack_public_path__ + "static/media/rotate-360.97b1d390426ee40edfb9e3ea47f7bd11.svg";
export { ForwardRef as ReactComponent };